import React from 'react';

import 'react-dates/initialize'
import { DayPickerSingleDateController } from 'react-dates'
import 'react-dates/lib/css/_datepicker.css'
import moment from 'moment'
// import './datepicker.css';

export default class  CustomDatePicker extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            selDate : this.props.depDate ? moment(new Date(this.props.depDate)) : null,
        }
    }

    checkOutsideRange = (param, e) => {
        let today = new Date();
        today.setHours(0,0,0,0)
        let ninety = new Date();
        ninety = ninety.setDate(ninety.getDate() + window.daysForCalendar);
        if (param === 'dep') {
            return !(today <= e._d && ninety > e._d);
        } else {
            if (this.state.selDate && this.state.selDate._d) {
                const selDate = this.state.selDate._d;
                return !(selDate < e._d && ninety > e._d);
            } else {
                return !(today < e._d && ninety > e._d);
            }
        }
    }

    onDateChange = (val) => {
        const selDate = moment(val).format("YYYY-MM-DD")
        this.setState({ selDate })
        this.props.onSelect(selDate)
    }
    
    render() {
        return (
            <div>
                <style jsx = "true">{`
                    .head-wrapper {
                        position: relative;
                        width: calc(100% - 30px);
                    }
                    .week-wrapper {
                        background: ${ window.searchBoxBgColor };
                        color: ${ window.menuBgColor };
                        padding: 15px;
                        margin-top: -1px;
                    }
                    .DayPicker {
                        height: calc(100vh - 103px);
                        overflow: hidden;
                    }
                    .DayPicker_weekHeaders,
                    .DayPickerNavigation__verticalDefault {
                        display: none;
                    }
                    .CalendarDay__default,
                    .CalendarDay__default:hover {
                        border: 0;
                        border-radius: 50%;
                        color: #444;
                    }
                    .DayPicker_transitionContainer__vertical {
                        overflow: auto;
                    }
                    .CalendarMonth {
                        border-bottom: 1px solid #eee;
                    }
                    .CalendarMonth_caption {
                        text-align: left;
                        padding: 15px;
                    }
                    .CalendarMonth_caption strong {
                        font-weight: 400;
                    }
                    .CalendarDay__selected, .CalendarDay__selected:active, .CalendarDay__selected:hover, .CalendarDay__default:hover {
                        background: ${ window.headerStripColor };
                        color: ${ window.menuBgColor };
                    }
                    .CalendarDay__blocked_out_of_range, .CalendarDay__blocked_out_of_range:active, .CalendarDay__blocked_out_of_range:hover {
                        background: transparent;
                        color: ${ window.menuBgColor };
                        opacity: 0.3;
                    }
                `}</style>
                <div>
                    <div onClick = { this.props.onClose }></div>
                    <div className = "head-wrapper">Journey date</div>
                </div>
                <div className = "week-wrapper flsac">
                    <span>Mon</span>
                    <span>Tue</span>
                    <span>Wed</span>
                    <span>Thu</span>
                    <span>Fri</span>
                    <span>Sat</span>
                    <span>Sun</span>
                </div>
                <DayPickerSingleDateController
                    date = { this.state.selDate }
                    onDateChange = { this.onDateChange }
                    numberOfMonths = {window.daysForCalendar>90 ? 6 :4 }
                    noBorder = { true }
                    firstDayOfWeek = { 1 }
                    hideKeyboardShortcutsPanel = { true }
                    orientation = "vertical"
                    daySize = { Math.round(window.innerWidth / 7) - 3 }
                    isOutsideRange = { (event) => this.checkOutsideRange('dep', event) }
                />
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/datepicker/CustomDatePicker.js